/**
 * Date helpers for budget pause/resume flows.
 *
 * Stephen 2026-05-23 — added with the spent-watermark PR. When a user lowers
 * a subchannel budget below MTD spend, we PATCH `smart_spend_paused_until` to
 * the end of the current UTC month so the channel doesn't keep spending for
 * the rest of the month.
 */

/**
 * Returns an ISO 8601 timestamp for the start of the *next* UTC month
 * (i.e. one tick past the end of the current month). Using the next-month
 * boundary avoids off-by-one ambiguity around "23:59:59.999".
 *
 * Examples:
 *   2026-05-23T10:15:00.000Z → "2026-06-01T00:00:00.000Z"
 *   2026-12-31T23:30:00.000Z → "2027-01-01T00:00:00.000Z"
 */
export function endOfMonthISO(now: Date = new Date()): string {
  const d = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0, 0),
  )
  return d.toISOString()
}
